export const QalboxInputWrapper = ({ label, component, style }) => {
  return (
    <div className="form-group" style={style}>
      <label>{label}</label>
      {component}
    </div>
  );
};
